(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["concrete-bundle"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mm-concrete-bundle-zone')) {
    class MmConcreteBundleZone extends HTMLElement {
      connectedCallback() {
        this.mobileQuery = window.matchMedia('(max-width: 749px)');
        this.isVisible = false;
        this.updateStickyState = this.updateStickyState.bind(this);
        this.mobileQuery.addEventListener('change', this.updateStickyState);
        this.observer = new IntersectionObserver((entries) => {
          this.isVisible = entries[0]?.isIntersecting || false;
          this.updateStickyState();
        }, { threshold: 0.15 });
        this.observer.observe(this);
      }

      updateStickyState() {
        document.documentElement.classList.toggle(
          'mm-concrete-bundle-active',
          this.mobileQuery.matches && this.isVisible
        );
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.mobileQuery?.removeEventListener('change', this.updateStickyState);
        document.documentElement.classList.remove('mm-concrete-bundle-active');
      }
    }

    customElements.define('mm-concrete-bundle-zone', MmConcreteBundleZone);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["concrete-kit-inventory"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mm-kit-shots')) {
    class MmKitShots extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        this.openButton = this.querySelector('[data-kit-open]');
        this.stage = this.querySelector('[data-kit-stage]');
        this.slides = Array.from(this.querySelectorAll('[data-kit-slide]'));
        this.counter = this.querySelector('[data-kit-current]');
        this.name = this.querySelector('[data-kit-name]');
        this.index = 0;

        if (!this.dialog || !this.slides.length) return;

        this.openButton?.addEventListener('click', () => {
          this.dialog.showModal();
          this.render();
          this.stage?.focus();
        });
        this.querySelector('[data-kit-close]')?.addEventListener('click', () => this.dialog.close());
        this.querySelector('[data-kit-prev]')?.addEventListener('click', () => this.step(-1));
        this.querySelector('[data-kit-next]')?.addEventListener('click', () => this.step(1));
        this.dialog.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.dialog.close();
        });
        this.dialog.addEventListener('close', () => this.openButton?.focus());

        this.stage.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.step(-1);
          } else if (event.key === 'ArrowRight') {
            event.preventDefault();
            this.step(1);
          }
        });

        // Swipe. Pointer events cover touch and mouse drag; the vertical guard
        // stops a scroll gesture from registering as a swipe.
        this.stage.addEventListener('pointerdown', (event) => {
          if (event.pointerType === 'mouse' && event.button !== 0) return;
          this.start = { x: event.clientX, y: event.clientY };
        });
        this.stage.addEventListener('pointerup', (event) => {
          if (!this.start) return;
          const dx = event.clientX - this.start.x;
          const dy = event.clientY - this.start.y;
          this.start = null;
          if (Math.abs(dx) < 44 || Math.abs(dx) < Math.abs(dy)) return;
          this.step(dx < 0 ? 1 : -1);
        });
        this.stage.addEventListener('pointercancel', () => {
          this.start = null;
        });

        this.render();
      }

      step(direction) {
        const total = this.slides.length;
        // Wrap, so the arrows are never dead ends.
        this.index = ((this.index + direction) % total + total) % total;
        this.render();
      }

      render() {
        this.slides.forEach((slide, i) => {
          const isActive = i === this.index;
          slide.classList.toggle('is-active', isActive);
          if (isActive) {
            slide.removeAttribute('aria-hidden');
          } else {
            slide.setAttribute('aria-hidden', 'true');
          }
          const image = slide.querySelector('img');
          // Eager-load the neighbours so a swipe never lands on a blank frame.
          if (image && Math.abs(i - this.index) <= 1) image.loading = 'eager';
        });
        if (this.counter) this.counter.textContent = String(this.index + 1).padStart(2, '0');
        if (this.name) this.name.textContent = this.slides[this.index]?.dataset.kitLabel || '';
      }
    }

    customElements.define('mm-kit-shots', MmKitShots);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.isManagedByGroup = false;

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      // Check if managed by StickyGroupManager (set after manager initializes)
      // Use MutationObserver to detect when managedByGroup attribute is set
      this.checkManagedStatus();

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      // Listen for sticky events from StickyGroupManager
      this.addEventListener('stickyHide', this.onManagedHide.bind(this));
      this.addEventListener('stickyReveal', this.onManagedReveal.bind(this));
      this.addEventListener('stickyReset', this.onManagedReset.bind(this));

      // Only attach scroll handler if not managed by group
      if (!this.isManagedByGroup) {
        this.onScrollHandler = this.onScroll.bind(this);
        window.addEventListener('scroll', this.onScrollHandler, false);
        this.createObserver();
      }
    }

    checkManagedStatus() {
      // Check if already managed
      if (this.dataset.managedByGroup === 'true') {
        this.isManagedByGroup = true;
        return;
      }

      // Watch for the attribute to be set by the manager
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === 'data-managed-by-group' && this.dataset.managedByGroup === 'true') {
            this.isManagedByGroup = true;
            // Remove scroll handler if it was attached
            if (this.onScrollHandler) {
              window.removeEventListener('scroll', this.onScrollHandler);
            }
            observer.disconnect();
          }
        });
      });

      observer.observe(this, { attributes: true });
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      if (this.onScrollHandler) {
        window.removeEventListener('scroll', this.onScrollHandler);
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      // Skip if managed by group
      if (this.isManagedByGroup) return;

      const scrollTop = window.scrollY || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    // Event handlers for when managed by StickyGroupManager
    onManagedHide() {
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    onManagedReveal() {
      // Any reveal-specific logic
    }

    onManagedReset() {
      // Any reset-specific logic
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();
})();
